
const Tagular = {
    sendElementClickedEvent(event, options) {
        const schema = 'redventures.usertracking.v3.ElementClicked';
        const configure = mappingStrategy(schema);

        const eventBody = configure(event, options);
        sendTagularEvent(schema, eventBody);
    },
    sendElementViewedEvent(options) {
        const schema = 'redventures.usertracking.v3.ElementViewed';
        const configure = mappingStrategy(schema);

        const eventBody = configure(options);
        sendTagularEvent(schema, eventBody);
    },
    sendProductClickedEvent(event, options) {
        const schema = 'redventures.ecommerce.v1.ProductClicked';
        const configure = mappingStrategy(schema);

        const eventBody = configure(event, options);
        sendTagularEvent(schema, eventBody);
    },
    sendFormSubmittedEvent(event, options) {
        const schema = 'redventures.usertracking.v3.FormSubmitted';
        const configure = mappingStrategy(schema);

        const eventBody = configure(event, options);
        sendTagularEvent(schema, eventBody);
    },
    sendFormStartedEvent(event, options) {
        const schema = 'redventures.usertracking.v3.FormStarted';
        const configure = mappingStrategy(schema);

        const eventBody = configure(event, options);
        sendTagularEvent(schema, eventBody);
    },
    sendFormOutcomeReceivedEvent(event, options) {
        const schema = 'redventures.usertracking.v3.FormOutcomeReceived';
        const configure = mappingStrategy(schema);
        const eventBody = configure(event, options);
        sendTagularEvent(schema, eventBody);
    },
    sendFieldSelectedEvent(event) {
        const schema = 'redventures.usertracking.v3.FieldSelected';
        const configure = mappingStrategy(schema);
        const eventBody = configure(event);
        sendTagularEvent(schema, eventBody);
    }    
};

const mappingStrategy = schema => {
    const strategies = {
        'redventures.usertracking.v3.ElementClicked': elementClicked,
        'redventures.usertracking.v3.ElementViewed': elementViewed,
        'redventures.ecommerce.v1.ProductClicked': productClicked,
        'redventures.usertracking.v3.FormSubmitted': formSubmitted,
        'redventures.usertracking.v3.FormStarted': formStarted,
        'redventures.usertracking.v3.FormOutcomeReceived': formOutcomeReceived,
        'redventures.usertracking.v3.FieldSelected': fieldSelected
    };

    if (!strategies[schema]) {
        return null;
    }

    return strategies[schema];
};

const elementClicked = (event, options) => {
    const body = {
        webElement: {
            location: options.location || 'SECTION',
            position: options.position || determinePositionByPath(options.assessmentName),
            elementType:
                options.elementType || determineElementTypeByClass(event.currentTarget.className),
            text: options.text || event.target.innerText || event.target.value,
            name: options.name || event.target.innerText || event.target.value,
            htmlId: options.htmlId || ''
        },
        outboundUrl: options.outboundUrl || '',
        actionOutcome: options.action
    };

    return body;
};

const elementViewed = options => {
    const body = {
        webElement: {
            location: options.location || 'SECTION',
            position: options.position || determinePositionByPath(options.assessmentName),
            elementType: options.elementType,
            text: options.text,
            name: options.name,
            htmlId: options.htmlId || ''
        }
    };

    return body;
};

const productClicked = (event, options) => {
    const body = {
        product: {
            brand: 'HL',
            category: options.category,
            productId: options.productId,
            formatType:
                options.formatType || determineElementTypeByClass(event.currentTarget.className),
            location: options.location || 'SECTION',
            text: options.text || event.currentTarget.innerText || event.currentTarget.value,
            name: options.name,
            variant: options.assessmentName
        }
    };

    return body;
};

const formSubmitted = (event, options) => {
    const body = {
        formContext: {
            formId: options.assessment.name,
            formName: options.assessment.eventConfig.assessmentVersion,
            formType: 'Quizzler_' + options.assessment.eventConfig.assessmentName
        },
        field: []
    };

    if (options.formElements) {
        for (const element of options.formElements) {
            body.field.push({
                fieldId: element.id,
                fieldName: element.question,
                fieldType: element.answerType,
                fieldValue: element.answer
            });
        }
    }

    return body;
};

const formStarted = (event, options) => {
    const body = {
        formContext: {
            formId: options.assessment.name,
            formName: options.assessment.eventConfig.assessmentVersion,
            formType: 'Quizzler_' + options.assessment.eventConfig.assessmentName
        }
    };

    return body;
};

const formOutcomeReceived = (event, options) => { 

    const body = {
        formContext: {
            formId: options.assessment.name,
            formName: options.assessment.eventConfig.assessmentVersion,
            formVersion: options.assessment.version,
            formType: 'Quizzler_' + options.assessment.eventConfig.assessmentName
        },
        formOutcome: [
            {
                key: 'primary_result',
                value: options.sortedResults[0].title
            },
            {
                key: 'secondary_result',
                value: options.sortedResults[1].title
            }
        ]
    };
  
    return body;
};

const fieldSelected = (options) => {

    const body = {
        formContext: {
            formBrand: options.pillarName,
            formName: options.assessment.eventConfig.assessmentVersion,
            formType: 'Quizzler_' + options.assessment.eventConfig.assessmentName
        },
        stepContext: {
            stepNumber: 1
        },
        userInputField: {
            autofilled: false,
            fieldLabel: options.question,
            fieldType: options.answerType || 'ANSWER',
            fieldValue: options.answer
        }
    }

    return body;
};

const determineElementTypeByClass = classNames => {
    const types = ['link', 'button', 'checkbox'];

    classNames = classNames.toLowerCase();

    let elementType = '';
    for (const type of types) {
        if (classNames.includes(type)) {
            elementType = type.toUpperCase();
        }
    }

    return elementType;
};

const determinePositionByPath = assessment => {
    // EX: /assessment/assessment/health-segments/results
    const { pathname } = window.location;

    const pathParts = pathname.split('/');

    if (pathParts.length < 5) {
        throw new Error('invalid path');
    }

    let position = pathParts[4];
    position = position[0].toUpperCase() + position.slice(1);

    return `${assessment || 'Assessment'} ${position}`;
};

const sendTagularEvent = (schema, body) => {
    tagular('beam', {
        '@type': schema,
        ...body
    });
};

export default Tagular;
